import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";

import { cn } from "./utils";

const Slider = React.forwardRef<
    React.ElementRef<typeof SliderPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
        thumb?: React.ReactNode;
        thumbClassName?: string;
    }
>(({ className, thumb, thumbClassName, orientation, value, defaultValue, ...props }, ref) => {
    const isVertical = orientation === "vertical";

    // Determine number of thumbs based on value or defaultValue
    const thumbCount = value?.length ?? defaultValue?.length ?? 1;

    return (
        <SliderPrimitive.Root
            ref={ref}
            orientation={orientation}
            value={value}
            defaultValue={defaultValue}
            className={cn(
                "relative flex touch-none select-none",
                isVertical ? "flex-col items-center h-full w-8" : "items-center w-full",
                className
            )}
            {...props}
        >
            <SliderPrimitive.Track
                className={cn(
                    "relative bg-indigo-100 dark:bg-indigo-800 rounded-full overflow-hidden grow",
                    isVertical ? "w-3 h-full" : "w-full h-3"
                )}
            >
                <SliderPrimitive.Range
                    className={cn("absolute bg-indigo-800 dark:bg-indigo-50", isVertical ? "w-full" : "h-full")}
                />
            </SliderPrimitive.Track>
            {Array.from({ length: thumbCount }).map((_, index) => (
                <SliderPrimitive.Thumb
                    key={index}
                    className={cn(
                        "block bg-white dark:bg-indigo-950 disabled:opacity-50 border-4 border-indigo-900 dark:border-indigo-50 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-950 dark:focus-visible:ring-indigo-300 ring-offset-white focus-visible:ring-offset-2 dark:ring-offset-indigo-950 w-8 h-8 transition-colors disabled:pointer-events-none",
                        thumbClassName
                    )}
                >
                    {thumb}
                </SliderPrimitive.Thumb>
            ))}
        </SliderPrimitive.Root>
    );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
